/** Deterministic 48-bit linear congruential generator for shared simulation state. */
export class SeededRandom {
  private seed = 0n;
  private static readonly MULT = 0x5deece66dn;
  private static readonly ADD = 0xbn;
  private static readonly MASK = (1n << 48n) - 1n;
  constructor(seed: number) {
    this.setSeed(seed);
  }
  static fromRaw(raw: bigint): SeededRandom {
    const r = new SeededRandom(0);
    r.seed = raw & SeededRandom.MASK;
    return r;
  }
  setSeed(seed: number): void {
    this.seed = (BigInt(seed) ^ SeededRandom.MULT) & SeededRandom.MASK;
  }
  private next(bits: number): number {
    this.seed = (this.seed * SeededRandom.MULT + SeededRandom.ADD) & SeededRandom.MASK;
    const half = this.seed >> BigInt(48 - bits);
    const shifted = this.seed >> BigInt(48 - bits);
    const raw = shifted & ((1n << BigInt(bits)) - 1n);
    void half;
    const signBit = 1n << BigInt(bits - 1);
    return raw >= signBit ? Number(raw - (1n << BigInt(bits))) : Number(raw);
  }
  nextInt(): number {
    return this.next(32);
  }
  below(n: number): number {
    return Math.abs(this.nextInt() % n);
  }
  rawSeed(): bigint {
    return this.seed;
  }
}
